var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating-bar flex"},_vm._l((5),function(index){return _c('div',{key:`i${index}`,class:_vm.clazz(index),on:{"click":function($event){return _vm.rate(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }